import { IxDivider } from './IxDivider.js';

window.customElements.define('ix-divider', IxDivider);
